import { useState } from "react";

export default function ImageWithSkeleton({
  src,
  alt = "",
  className = "",
  containerClassName = "",
  style = {},
  ...props
}) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className={`relative overflow-hidden ${containerClassName}`}>
      {/* Shimmer skeleton background visible while image is loading */}
      {!loaded && !error && (
        <div className="absolute inset-0 bg-gray-200 animate-shimmer z-10" />
      )}

      {/* Actual Image */}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setLoaded(true);
          setError(true);
        }}
        className={`${className} transition-opacity duration-300 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        style={style}
        {...props}
      />
    </div>
  );
}
